import React from "react";
import {
  getKgNodeIcon,
  KG_NODE_ICON_SIZE,
} from "../../kg/canvas/kgNodeIcons";
import { KgInspectorExpandableSection } from "../KgInspectorExpandableSection";
import type { KgInspectorUsedInTabProps } from "./KgInspectorUsedInTab.types";
import { EmptyHint, TabRoot } from "./KgInspectorUsedInTab.styles";

const DEFAULT_EMPTY_HINT =
  "Nothing downstream uses this data source yet.";

export const KgInspectorUsedInTab: React.FC<KgInspectorUsedInTabProps> = ({
  sections,
  expandedSectionIds,
  onToggleSection,
  emptyHint = DEFAULT_EMPTY_HINT,
}) => (
  <TabRoot>
    {sections.length === 0 ? (
      <EmptyHint>{emptyHint}</EmptyHint>
    ) : (
      sections.map((section) => {
        const NodeIcon = getKgNodeIcon(section.nodeType);
        return (
          <KgInspectorExpandableSection
            key={section.id}
            variant="linkRows"
            icon={<NodeIcon size={KG_NODE_ICON_SIZE} />}
            label={section.label}
            items={section.items}
            isOpen={expandedSectionIds[section.id] ?? false}
            onToggle={() => onToggleSection(section.id)}
            compact
          />
        );
      })
    )}
  </TabRoot>
);

export default KgInspectorUsedInTab;
